import React from 'react';
import classnames from 'classnames';
import Image from 'next/image';

import styles from './dashboard-icons.module.scss';

interface IconProps {
  small?: boolean;
}

export const AccountLinkingIcon: React.FC<IconProps> = ({ small }) => (
  <Image
    className={classnames(styles.accountLinking, small && styles.small)}
    src="https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/images/reconnecting-spinner.svg"
    height={24}
    width={24}
    alt=""
  />
);

export const AccountWarningIcon: React.FC<IconProps> = ({ small }) => (
  <Image
    className={classnames(styles.accountWarning, small && styles.small)}
    src="https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/images/sync-alert.svg"
    height={24}
    width={24}
    alt=""
  />
);
